if (!customElements.get('kn-footer')) {
  customElements.define('kn-footer', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.lifecycle = new AbortController();
      this.updateMode = () => {
        this.mobileListeners?.abort();
        const mobile = this.media.matches;
        this.querySelectorAll('.kf-col').forEach((column) => {
          const button = column.querySelector('.kf-toggle');
          const panel = column.querySelector('.kf-panel');
          column.removeAttribute('data-open');
          button.setAttribute('aria-expanded', 'false');
          panel.inert = mobile;
        });
        if (!mobile) return;
        this.mobileListeners = new AbortController();
        const signal = this.mobileListeners.signal;
        this.querySelectorAll('.kf-toggle').forEach((button) => {
          button.addEventListener('click', () => this.toggle(button.closest('.kf-col')), { signal });
        });
        this.addEventListener('shopify:block:select', (event) => {
          const column = event.target.closest('.kf-col');
          if (column && !column.hasAttribute('data-open')) this.toggle(column);
        }, { signal });
      };
      this.media.addEventListener('change', this.updateMode, { signal: this.lifecycle.signal });
      this.updateMode();
    }

    toggle(column) {
      if (!this.media.matches) return;
      const open = !column.hasAttribute('data-open');
      column.toggleAttribute('data-open', open);
      column.querySelector('.kf-toggle').setAttribute('aria-expanded', String(open));
      column.querySelector('.kf-panel').inert = !open;
    }

    disconnectedCallback() {
      this.mobileListeners?.abort();
      this.lifecycle?.abort();
    }
  });
}
